<!--
  黑金 V2 · 选择用餐人数
  目录：views/SelfHelp/blackV2
  业务逻辑复用 InputPeopleNum
-->
<template>
  <div class="bv2-people-page">
    <header class="bv2-people-hero">
      <img src="@/assets/images/point-user.png" alt="" class="bv2-people-avatar" />
      <p class="bv2-people-welcome">亲爱的顾客，欢迎您用餐～</p>
      <p v-if="deskCodeText" class="bv2-people-desk">桌台号：{{ deskCodeText }}</p>
    </header>

    <section class="bv2-people-panel">
      <h1>请问您几人用餐？</h1>
      <p class="bv2-people-tip">请选择人数</p>

      <div class="bv2-people-grid">
        <button
          v-for="item in 11"
          :key="item"
          type="button"
          :class="{ active: tableNumber == item }"
          @click="onClickTableNumber(item)"
        >
          {{ item }}
        </button>
        <button
          type="button"
          :class="{ active: tableNumber == 'more' }"
          @click="onClickTableNumber('more')"
        >
          更多
        </button>
      </div>

      <div v-if="tableNumber == 'more'" class="bv2-people-input-wrap">
        <input
          v-model="inputTableNumber"
          type="number"
          inputmode="numeric"
          maxlength="3"
          placeholder="请输入人数"
        />
      </div>

      <button type="button" class="bv2-people-submit" @click="handleToOrderPage">
        {{ submitText }}
      </button>
    </section>

    <van-overlay
      :show="showSelectModal"
      z-index="5"
      class="bv2-overlay"
      :style="overlayStyle"
    >
      <div class="bv2-dialog">
        <strong>温馨提示</strong>
        <ul>
          <li>合理点餐，请勿浪费食物～</li>
          <li>未成年人请勿饮酒！</li>
        </ul>
        <div class="bv2-dialog-iKnow">
          <button type="button" class="bv2-dialog-btn gold" @click="closedailog">
          我已知悉
        </button>
        </div>
      </div>
    </van-overlay>
     <!-- 去掉弹框提示 ，这不是团队点餐，是是否有历史订单提示-->
    <!-- <van-overlay
      :show="showEnableTeamOrder"
      z-index="999"
      class="bv2-overlay"
      :style="overlayStyle"
    >
      <div class="bv2-dialog">
        <strong>温馨提示</strong>
        <p class="bv2-dialog-copy">
          您好，这张桌子已经有人点过餐，请问您还要继续点餐吗？
        </p>
        <div class="bv2-dialog-actions">
          <button
            type="button"
            class="bv2-dialog-btn ghost"
            @click="showEnableTeamOrder = false"
          >
            继续点餐
          </button>
          <button type="button" class="bv2-dialog-btn gold" @click="goToHistouryConsume">
            查看已点餐品
          </button>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
import InputPeopleNum from "../InputPeopleNum.vue";
import {
  getBlackMicropointRouteName,
  getBlackRecordConsumeRouteName,
  handleSessionStorage,
} from "@/utils";

export default {
  name: "BlackInputPeopleNumV2",
  extends: InputPeopleNum,
  data() {
    return {
      overlayStyle: {
        background: "rgba(0, 0, 0, 0.72)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
      },
    };
  },
  computed: {
    deskCodeText() {
      const deskCode = handleSessionStorage.get("deskCode");
      return deskCode && deskCode.code ? deskCode.code : "";
    },
    submitText() {
      if (this.fromPage === "NewPlaceOrder" && !this.isFromMicropoint) {
        return "确定";
      }
      return this.isFromMicropoint ? "继续下单" : "开始点餐";
    },
  },
  mounted() {
    this.applyPageTheme();
  },
  beforeDestroy() {
    this.restorePageTheme();
  },
  methods: {
    applyPageTheme() {
      this._pageThemeSnapshot = {
        bodyBackground: document.body.style.backgroundColor,
      };
      document.body.style.backgroundColor = "#000";
    },
    restorePageTheme() {
      if (!this._pageThemeSnapshot) return;
      document.body.style.backgroundColor =
        this._pageThemeSnapshot.bodyBackground || "";
    },
    goToHistouryConsume() {
      this.showEnableTeamOrder = false;
      this.$router.push({
        name: getBlackRecordConsumeRouteName(),
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    handleToOrderPage() {
      if (this.tableNumber == "more" && !this.inputTableNumber) {
        this.$toast("请输入就餐人数");
        return;
      }
      this.handleChangePeopleNum();
      this.$router.replace({
        name: getBlackMicropointRouteName(),
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$bg: #000;
$panel: #1a1a1a;
$gold: #ffc653;
$gold-gradient: linear-gradient(120deg, #e5c15e, #fff0ba 48%, #e9c769);
$text: #fff;
$muted: #8f8f8f;
$soft: #cfcfcf;
$btn-text: #20201e;

.bv2-people-page {
  min-height: 100vh;
  padding: 40px 24px calc(40px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: $text;
  background: linear-gradient(180deg, #3b3a3a 0%, #222120 100%);
  color-scheme: dark;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.bv2-people-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 36px;
  text-align: center;
}

.bv2-people-avatar {
  width: 120px;
  height: 120px;
  margin-bottom: 40px;
}

.bv2-people-welcome {
  margin-bottom: 20px;
  color: $soft;
  font-size: 28px;
  line-height: 40px;
}

.bv2-people-desk {
  margin: 12px 0 0;
  color: $gold;
  font-size: 30px;
  font-weight: 600;
}

.bv2-people-panel {
  padding: 46px 24px 40px;
  border: 1px solid rgba(255, 198, 83, 0.18);
  border-radius: 16px;
  background: rgba(26, 26, 26, 0.92);

  h1 {
    margin: 0;
    color: $text;
    font-size: 34px;
    font-weight: 600;
    text-align: center;
  }
}

.bv2-people-tip {
  position: relative;
  margin: 68px 0 32px;
  color: $muted;
  text-align: center;
  font-size: 24px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 72px;
    height: 1px;
    background: rgba(255, 198, 83, 0.35);
  }

  &::before {
    left: 12%;
  }

  &::after {
    right: 12%;
  }
}

.bv2-people-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 26px 16px;
  margin-bottom: 24px;

  button {
    height: 72px;
    border: 0;
    border-radius: 8px;
    color: $text;
    background: #2b2b2b;
    font-size: 28px;

    &.active {
      color: $btn-text;
      background: $gold-gradient;
      font-weight: 600;
    }
  }
}

.bv2-people-input-wrap {
  margin-bottom: 28px;

  input {
    width: 100%;
    height: 80px;
    padding: 0 24px;
    border: 1px solid rgba(255, 198, 83, 0.28);
    border-radius: 8px;
    box-sizing: border-box;
    color: $text;
    background: #2f2f2f;
    font-size: 28px;
    outline: 0;

    &::placeholder {
      color: $muted;
    }
  }
}

.bv2-people-submit {
  display: block;
  width: 100%;
  height: 82px;
  border: 0;
  border-radius: 10px;
  color: $btn-text;
  background: $gold-gradient;
  font-size: 32px;
  font-weight: 600;
  margin-top: 82px;
}

.bv2-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.bv2-dialog {
  width: 100%;
  max-width: 640px;
  padding: 32px 28px 28px;
  border: 1px solid rgba(255, 198, 83, 0.22);
  border-radius: 16px;
  background: linear-gradient(180deg, #3b3a3a 0%, #222120 100%);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  color: $text;

  > strong {
    display: block;
    margin-bottom: 24px;
    font-size: 32px;
    text-align: center;
  }

  ul {
    margin: 0 0 82px;
    padding: 0;
    list-style: none;

    li {
      position: relative;
      padding-left: 22px;
      color: $soft;
      font-size: 26px;
      line-height: 42px;

      &::before {
        content: "";
        position: absolute;
        top: 18px;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: $gold;
      }

      & + li {
        margin-top: 8px;
      }
    }
  }
}

.bv2-dialog-copy {
  margin: 0 0 36px;
  color: $soft;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
}

.bv2-dialog-actions {
  display: flex;
  gap: 16px;
}
.bv2-dialog-iKnow{
  text-align: center;
}
.bv2-dialog-btn {
  width: 220px;
  height: 78px;
  border: 0;
  border-radius: 10px;
  font-size: 28px;
  font-weight: 500;

  &.ghost {
    color: $soft;
    background: #2b2b2b;
  }

  &.gold {
    color: $btn-text;
    background: $gold-gradient;
  }
}
</style>
